import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    paddingTop: '15px',
    backgroundColor: theme.palette.whitePepper.main,

    [theme.breakpoints.up(720)]: {
      padding: '40px 50px',
      backgroundColor: theme.palette.turmeric.main,
    },
  },

  container: {
    paddingTop: '120px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up(720)]: {
      paddingTop: '0',
      flexDirection: 'row',
      columnGap: '60px',
    },
  },

  imgWrapper: {
    flexShrink: '0',
    position: 'relative',
    width: '230px',
    height: '230px',

    [theme.breakpoints.down(720)]: {
      width: '200px',
      height: '200px',
      position: 'absolute',
      top: '0px',
    },
  },

  rightContainer: {
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    rowGap: '10px',

    [theme.breakpoints.down(720)]: {
      alignItems: 'center',
      backgroundColor: theme.palette.turmeric.main,
      padding: '110px 30px 30px',
    },
  },
});
